import { get } from './get';

export const DEFAULT_ERROR_MESSAGE = 'Whoops, something went wrong. Please try again.';

/**
 * Returns a normalized error string from any of the stash error response
 * types.
 */
export const getErrorMessage = (error, fallbackMessage = DEFAULT_ERROR_MESSAGE) => {
  try {
    const errors = error && (error.errors || error.body);

    if (!errors) {
      return fallbackMessage;
    }

    if (Array.isArray(errors)) {
      return errors
        .map(error => {
          return typeof error === 'object' ? error.message : error;
        })
        .join(' ');
    } else if (typeof errors === 'object') {
      return get(errors, 'message', fallbackMessage);
    } else {
      return errors;
    }
  } catch {
    return fallbackMessage;
  }
};

export const tryWarn = fn => (...args) => {
  try {
    const result = fn(...args);
    // If the wrapped function returns a Promise, attach a rejection handler
    if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
      result.catch(error => {
        console.warn(error);
      });
    }
    return result;
  } catch (error) {
    console.warn(error);
  }
};
